<template>
		<v-navigation-drawer
			disable-route-watcher
			v-model="drawer"
			temporary
			app
			width="300"
			class="left-bar"
		>
			<left-bar-items />
		</v-navigation-drawer>
		<!--
		<v-navigation-drawer
			v-if="$vuetify.breakpoint.mdAndDown"
			app
			:class="['left-bar', backgroundColor]"
			mobile-breakpoint="420"
			width="400"
			:mini-variant="$vuetify.breakpoint.lgAndDown"
			:expand-on-hover="$vuetify.breakpoint.lgAndDown"
			:value.sync="show"
			disable-route-watcher
			v-resize="onResize"
		>
			<div class="d-flex flex-row justify-content-between w-100">
				<img src="@/assets/logo.svg" class="logo" height="36" />
				<v-btn @click="show = false" icon class="toggler d-block d-md-none"
					><v-icon>mdi-arrow-left</v-icon></v-btn
				>
			</div>
			<left-bar-items />
		</v-navigation-drawer>
		-->
</template>

<script>
import LeftBarItems from '@/components/left-bar/LeftBarItems'
import {mapGetters} from 'vuex';
export default {
	components: {
		LeftBarItems
	},
	data() {
		return {
			show: true,
			miniVariant: false,
			drawer: false
		};
	},
	computed: {
		...mapGetters({
			menu: 'application/menu'
		}),
		backgroundColor: function () {
			return this.$vuetify.theme.dark ? "black" : "white";
		},
	},
	watch: {
		drawer(val) {
			if(val !== this.menu) {
				console.log("DRAWER CHANGED", val)
				this.$store.commit('application/setMenu', val)
			}
		},
		menu(val) {
			if(val !== this.drawer) {
				console.log("DRAWER CHANGED", val)
				this.drawer = val
			}
		},
		'$route.path': function() {
			this.$store.commit('application/setMenu', false)
		}
	},
	methods: {
		toggle() {
			this.show = !this.show;
		},
		input(v) {
			this.show = v;
		},
		onResize() {
			if (this.$vuetify.breakpoint.lgAndUp) {
				this.show = true;
			}
		},
	},
	created() {
		if (this.$vuetify.breakpoint.lgAndUp) {
			this.show = true;
		} else {
			this.show = false;
		}
	},
};
</script>

<style lang="scss">

// 12px 16px
</style>
